import type { ButtonHTMLAttributes } from 'react'
import React from 'react'
import type { IconComponent } from '../Icon'
import { Icon } from '../Icon'
import * as S from './IconButton.styled'
import type { IconButtonSize, IconButtonVariant } from './IconButton.types'

type IconButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  icon: IconComponent
  size?: IconButtonSize
  variant?: IconButtonVariant
}

const iconSizeMap: Record<IconButtonSize, number> = {
  large: 20,
  medium: 18,
  small: 16,
  micro: 12,
}

export const IconButton = ({
  icon,
  size = 'medium',
  variant = 'standard',
  type = 'button',
  ...rest
}: IconButtonProps) => {
  return (
    <S.Container $size={size} $variant={variant} type={type} {...rest}>
      <Icon component={icon} height={iconSizeMap[size]} />
    </S.Container>
  )
}
